export const EMOTION_TYPES = [
  { id: "joy", name: "Радость" },
  { id: "relief", name: "Облегчение" },
  { id: "fear", name: "Страх" },
  { id: "surprise", name: "Удивление" },
  { id: "sadness", name: "Грусть" },
  { id: "annoyance", name: "Раздражение" },
  { id: "anger", name: "Гнев" },
  { id: "thoughtful", name: "Задумчивость" },
];

export const EMOTION_LEVELS = [
  { id: 1, name: "1 — низкий" },
  { id: 2, name: "2 — средний" },
  { id: 3, name: "3 — высокий" },
];
